import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { AggregatedJobLog } from "@ea/shared_types/types";
import { moduleActions } from "./aggregatedJobLogs.actions";

const initialState = {
  ...getDataReducerInitialState<AggregatedJobLog>(),
};

export type AggregatedJobLogsReducer = typeof initialState;

const dataReducer = createDataReducer<AggregatedJobLog>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
